import Button from 'tailwind-components/Button/Button';
import Modal from 'tailwind-components/Modal/Modal';
import PropTypes from 'prop-types';
import React from 'react';
import style from '../DashboardCustomer.module.scss';
import { useMemo } from 'react';

import {
  MaterialReactTable,
  useMaterialReactTable
} from 'material-react-table';

const PotentialMatchesModal = ({
  potentialMatchesData,
  handleClosePotentialMatchesModal,
  loadingPotentialMatches,
  deleteBobMatch,
  confirmBobMatch
}) => {
  return (
    <Modal
      size='xlarger'
      active={potentialMatchesData.HsPolicyId}
      title={
        loadingPotentialMatches || !potentialMatchesData.originalPolicy
          ? 'Potential Matches'
          : 'Selected Submission'
      }
      isLoading={loadingPotentialMatches}
      footer={
        <div
          className={style.wrapButtonsSmall}
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '15px',
            justifyContent: 'space-between'
          }}
        >
          <Button
            fill
            variant='primaryDarkened'
            text='Close'
            onClick={handleClosePotentialMatchesModal}
          />
        </div>
      }
      closeModal={handleClosePotentialMatchesModal}
    >
      <div
        style={{
          position: 'sticky',
          top: 0,
          backgroundColor: '#E3F6FF',
          padding: '16px',
          borderRadius: '8px',
          zIndex: 10,
          marginBottom: '24px'
        }}
      >
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '14px'
          }}
        >
          <thead>
            <tr style={{ textAlign: 'left' }}>
              <th>Client</th>
              <th>Carrier</th>
              <th>Carrier Policy #</th>
              <th>Issuer Sub #</th>
              <th>FFM App #</th>
              <th>State</th>
              <th>NPN</th>
              <th>AOR Name</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{potentialMatchesData.originalPolicy?.Client}</td>
              <td>{potentialMatchesData.originalPolicy?.Carrier}</td>
              <td>
                {potentialMatchesData.originalPolicy?.CarrierPolicyNumber}
              </td>
              <td>{potentialMatchesData.originalPolicy?.IssuerSubID}</td>
              <td>{potentialMatchesData.originalPolicy?.FFMAppID}</td>
              <td>{potentialMatchesData.originalPolicy?.State}</td>
              <td>{potentialMatchesData.originalPolicy?.Npn}</td>
              <td>{potentialMatchesData.originalPolicy?.AorName}</td>
            </tr>
            <tr>
              <td colSpan={8} style={{ height: '14px' }}></td>
            </tr>
          </tbody>
          <thead>
            <tr style={{ textAlign: 'left' }}>
              <th>Email</th>
              <th>Phone #</th>
              <th>Zip Code</th>
              <th>Submission</th>
              <th>Gross</th>
              <th>Net</th>
              <th colSpan={2}>Residence</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{potentialMatchesData.originalPolicy?.email}</td>
              <td>{potentialMatchesData.originalPolicy?.phone}</td>
              <td>{potentialMatchesData.originalPolicy?.zipCode}</td>
              <td>
                {potentialMatchesData.originalPolicy?.Created?.split('T')[0] ||
                  'N/A'}
              </td>
              <td>${potentialMatchesData.originalPolicy?.Gross}</td>
              <td>${potentialMatchesData.originalPolicy?.Net}</td>
              <td colSpan={2}>
                {potentialMatchesData.originalPolicy?.Residence}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p
        style={{
          fontSize: '20px',
          color: '#2d83ba',
          fontWeight: 600,
          marginBottom: 4
        }}
      >
        Potential Matches
      </p>
      <PotentialMatchesTable
        potentialMatchesData={potentialMatchesData}
        deleteBobMatch={deleteBobMatch}
        confirmBobMatch={confirmBobMatch}
      />
    </Modal>
  );
};

PotentialMatchesModal.propTypes = {
  potentialMatchesData: PropTypes.object,
  handleClosePotentialMatchesModal: PropTypes.func,
  loadingPotentialMatches: PropTypes.bool,
  deleteBobMatch: PropTypes.func,
  confirmBobMatch: PropTypes.func
};

export default PotentialMatchesModal;

const PotentialMatchesTable = ({
  potentialMatchesData,
  deleteBobMatch,
  confirmBobMatch
}) => {
  const columns = useMemo(
    () => [
      {
        header: 'Action',
        enableResizing: false,
        size: 230,
        Cell: ({ cell }) => {
          const currentMatch =
            cell.row.original.id === potentialMatchesData.currentBobMatchId;

          return (
            <Button
              text={currentMatch ? 'Remove Association' : 'Confirm Association'}
              size='medium'
              className={style.buttonNoWrap}
              variant={currentMatch ? 'danger' : 'primaryDarkened'}
              isDisabled={
                potentialMatchesData.currentBobMatchId !== '' && !currentMatch
              }
              onClick={
                currentMatch
                  ? () => {
                      deleteBobMatch();
                    }
                  : () => {
                      confirmBobMatch(
                        cell.row.original.WritingAgentNPNFromBOB,
                        cell.row.original.id
                      );
                    }
              }
            />
          );
        }
      },
      {
        header: 'Holder',
        accessorKey: 'Holder',
        meta: { dbFields: ['First_Name', 'Last_Name'] }
      },
      {
        header: 'Bob Status',
        /* eslint react/prop-types: 0 */
        Cell: ({ cell }) => {
          const dropped = cell.row.original.bobExlude === 'Y';
          const currentDate = new Date();
          const inactive =
            (cell.row.original.BOBRemovedDate &&
              new Date(cell.row.original.BOBRemovedDate) <= currentDate) ||
            (cell.row.original.BOBInactiveDate &&
              new Date(cell.row.original.BOBInactiveDate) <= currentDate);

          return (
            <div
              style={{
                color: dropped ? 'red' : inactive ? 'orange' : '#3dcc21'
              }}
            >
              {dropped ? 'Dropped' : inactive ? 'Inactive' : 'Active'}
            </div>
          );
        }
      },
      {
        header: 'Phone',
        accessorKey: 'HolderPhone',
        meta: { dbFields: ['Phone'] }
      },
      {
        header: 'Email',
        accessorKey: 'EmailAddress',
        size: 250,
        meta: { dbFields: ['Email'] }
      },
      {
        header: 'Carrier',
        accessorKey: 'carriername',
        meta: { dbFields: ['Carrier'] }
      },
      {
        header: 'FFM App ID',
        accessorKey: 'FFMAppId',
        meta: { dbFields: ['ffm_app_id', 'ffm_subscriber_id'] }
      },
      {
        header: 'Carrier Policy #',
        accessorKey: 'CarrierPolicyNbr',
        meta: { dbFields: ['policy_id', 'issuer_assigned_subscriber_id'] }
      },
      {
        header: 'State',
        size: 90,
        accessorKey: 'HolderState',
        meta: { dbFields: ['State'] }
      },
      {
        header: 'Writing Agent BOB',
        accessorKey: 'WritingAgentNameFromBOB',
        meta: { dbFields: ['Agent'] }
      },
      {
        header: 'Writing Agent NPN',
        accessorKey: 'WritingAgentNPNFromBOB',
        meta: { dbFields: ['NPN'] }
      },
      {
        header: 'Removed Date',
        accessorKey: 'BOBRemovedDate',
        Cell: ({ cell }) => {
          const date = cell.getValue()?.split('T')[0]?.split('-') ?? '';
          const year = date[0],
            month = date[1],
            dt = date[2];

          return (
            <div>
              {year > 2100 ? 'N/A' : date ? `${month}-${dt}-${year}` : '-'}
            </div>
          );
        }
      },
      {
        header: 'Inactive Date',
        accessorKey: 'BOBInactiveDate',
        Cell: ({ cell }) => {
          const date = cell.getValue()?.split('T')[0]?.split('-') ?? '';
          const year = date[0],
            month = date[1],
            dt = date[2];

          return (
            <div>
              {year > 2100 ? 'N/A' : date ? `${month}-${dt}-${year}` : '-'}
            </div>
          );
        }
      }
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data: [...potentialMatchesData.potentialBobMatches].map(item => ({
      ...item.CallidusBooksOfBusinessEntity,
      bob_partial_match: item.bob_partial_match.split(',').map(f => f.trim())
    })),
    muiTableBodyCellProps: ({ cell }) => {
      const { column, row } = cell;
      const matchFields = row.original.bob_partial_match || [];
      const dbFields = column.columnDef.meta?.dbFields || [];
      const style = {};
      if (column.columnDef.header === 'Holder') {
        const hasFirst = matchFields.includes('First_Name');
        const hasLast = matchFields.includes('Last_Name');

        if (hasFirst && hasLast) {
          style.backgroundColor = 'rgba(59, 255, 69, 0.3)';
        } else if (!hasFirst && hasLast) {
          style.backgroundColor = 'rgba(255, 235, 59, 0.3)';
        }
      } else {
        const shouldHighlight = dbFields.some(f => matchFields.includes(f));
        if (shouldHighlight) {
          style.backgroundColor = 'rgba(59, 255, 69, 0.3)';
        }
      }

      return { style };
    },
    enableColumnActions: false,
    enableColumnResizing: true,
    enableTopToolbar: false,
    enableSorting: false,
    enableRowSelection: false,
    enableStickyHeader: true,
    enableBottomToolbar: false, //hide the bottom toolbar as well if you want
    rowCount: potentialMatchesData.potentialBobMatches.length,
    muiTablePaperProps: {
      elevation: 0, //change the mui box shadow
      style: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: 0
      },
      className: style.potentialMatchesTableHeight
    },
    muiTableContainerProps: {
      id: 'customers-bob-potential-body',
      style: {
        flex: 1,
        scrollbarWidth: 'auto'
      }
    },
    muiTableHeadCellProps: {
      style: {
        backgroundColor: '#FAFAFA'
      }
    },
    renderEmptyRowsFallback: () => (
      <h2
        style={{
          color: 'grey',
          textAlign: 'center',
          fontWeight: '400',
          fontSize: 14,
          padding: 15
        }}
      >
        No potential BOB matches found
      </h2>
    )
  });
  return <MaterialReactTable table={table} />;
};

PotentialMatchesTable.propTypes = {
  potentialMatchesData: PropTypes.object,
  confirmBobMatch: PropTypes.func,
  deleteBobMatch: PropTypes.func
};
